import type { IWorkOrderForm } from '@/interfaces/work-orders/IWorkOrderForm'
import DecoratorBase from '@/models/DecoratorBase'
import { AnnotateProperty } from '@/utils/helpers'
import DecoratorTypes from '@/enum/DecoratorTypes'
import JobType from '@/enum/jobs/JobType'
import type { IAttachment, ITemplateForm } from '@/interfaces'
import type { JobPriorityType } from '@/enum'
import type { WorkOrderStatusType } from '@/enum/WorkOrderStatusType'

class WorkOrderForm extends DecoratorBase implements IWorkOrderForm {
  @AnnotateProperty(DecoratorTypes.Displayable)
  @AnnotateProperty(DecoratorTypes.Required)
  title: string

  @AnnotateProperty(DecoratorTypes.Displayable)
  type: string | JobType | null

  @AnnotateProperty(DecoratorTypes.Displayable)
  description?: string | null

  priority: JobPriorityType | string | number

  status: WorkOrderStatusType | string | number

  url?: string

  assignee: string

  isRecurring: boolean

  startDate: string

  endDate: string

  expectedCompletionDate: string | null

  attachments: IAttachment[]

  templates: ITemplateForm[]

  constructor(workOrder?: any) {
    super(workOrder)
    this.title = workOrder?.title
    this.type = JobType.WORK_ORDER
    this.description = workOrder?.description
    this.priority = workOrder?.priority
    this.status = workOrder?.status
    this.url = workOrder?.url
    this.assignee = workOrder?.assignee
    this.isRecurring = workOrder?.isRecurring
    this.startDate = workOrder?.startDate
    this.endDate = workOrder?.endDate
    this.expectedCompletionDate = workOrder?.expectedCompletionDate
    this.attachments = workOrder?.attachments ?? []
    this.templates = workOrder?.templates ?? []
  }
}

export default WorkOrderForm
